import { Box, BoxProps } from "@mui/material";
import clsx from "clsx";
import theme from "theme";
import { MutableRefObject } from "react";

interface OtherProps {
  gap?: number;
  centered?: boolean;
  innerRef?: MutableRefObject<HTMLElement | null>;
}

const Flex = (props: BoxProps & OtherProps): JSX.Element => {
  const { className, gap, centered, innerRef, ...otherProps } = props;
  return (
    <Box
      ref={innerRef}
      display="flex"
      flexDirection="column"
      sx={{
        ...otherProps.sx,
        gap: gap ? theme.spacing(gap) + "px" : undefined,
        alignItems: centered ? "center" : undefined,
        justifyContent: centered ? "center" : undefined,
      }}
      className={clsx(className)}
      {...otherProps}
    />
  );
};

export default Flex;
